import { useTranslation } from 'react-i18next';
import { Card, Col, Row } from 'reactstrap';

import { TranslationsKeys } from '../../../locales/translations';
import { AcademicOfferFormDataLoader } from './hooks/AcademicOfferFormDataLoader';
import { AcademicOffersLoader } from './hooks/AcademicOffersLoader';
import { AcademicOffersSearch } from './parts/AcademicOffersSearch';
import { AcademicOffersTable } from './parts/AcademicOffersTable';
import { CreateOfferButton } from './parts/CreateOfferButton';

export function AcademicOffers() {
  const { t } = useTranslation(
    TranslationsKeys.CONTINUOUS_EDUCATION_ACADEMIC_OFFERS,
  );

  return (
    <Card className="p-4 mt-2 mx-3">
      <h2 className="text-primary fs-20 fw-700 mb-4 text-uppercase">
        {t('title')}
      </h2>
      <AcademicOfferFormDataLoader fetchImmediately>
        <AcademicOffersLoader
          defaultQuery={{ page: 1, items_per_page: 10 }}
          fetchImmediately
        >
          <Row>
            <Col xs={12}>
              <AcademicOffersSearch />
            </Col>
            <Col xs={12}>
              <CreateOfferButton />
            </Col>
            <Col xs={12}>
              <AcademicOffersTable />
            </Col>
          </Row>
        </AcademicOffersLoader>
      </AcademicOfferFormDataLoader>
    </Card>
  );
}
